var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModal
        ? _c(
            "app-modal",
            {
              attrs: {
                closeOutside: false,
                titulo: _vm.isEdit ? "Edição Sócio" : "Adicionar Sócio",
                width: 1000
              },
              on: { closeModal: _vm.cancelar }
            },
            [
              _c("template", { slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "modal-body-socio" },
                  [
                    _c(
                      "validation-observer",
                      { ref: "observerSocio" },
                      [
                        _c("app-pessoa-socio-retificacao", {
                          attrs: { pessoa: _vm.socio }
                        }),
                        _c("app-documentos-retificacao", {
                          attrs: {
                            maxSize: 25,
                            "valid-extensions": ["pdf", "rar", "zip"],
                            documentos: _vm.socio.documentos,
                            tiposDocumentos: _vm.documentos,
                            tiposDocumentosObrigatorios:
                              _vm.documentosObrigatoriosControle,
                            aba: "Interessado",
                            observer: _vm.$refs.observerSocio
                          },
                          on: {
                            addedDoc: _vm.handleDocs,
                            removedDoc: _vm.removerDocs
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "default" },
                        on: { click: _vm.cancelar }
                      },
                      [_vm._v("Cancelar")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.adicionarSocio }
                      },
                      [_vm._v(_vm._s(_vm.isEdit ? "Atualizar" : "Adicionar"))]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e(),
      _c(
        "app-divider",
        { attrs: { label: "Listagem de Sócio e Representante Legal" } },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "btn-adicionar" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.openModalAdicionar }
                  },
                  [
                    _c("i", { staticClass: "fal fa-plus" }),
                    _vm._v("  Adicionar")
                  ]
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _c(
        "el-row",
        [
          _c("validation-provider", {
            attrs: {
              rules: _vm.requireSocioRepresentante(),
              name: "Interessado/Sócio e Representante Legal",
              value: _vm.listSocios
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "input",
                        class: { "erro box-error": errors.length }
                      },
                      [
                        _c(
                          "el-table",
                          { attrs: { data: _vm.listSocios } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "empty" }, slot: "empty" },
                              [_c("span", [_vm._v("Não há registros.")])]
                            ),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pessoa.pessoaFisica.cpf",
                                label: "CPF",
                                align: "left"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pessoa.pessoaFisica.nome",
                                label: "Nome"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                formatter: _vm.funcaoSocios,
                                label: "Função"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Ações",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-dropdown",
                                          {
                                            attrs: {
                                              trigger: "click",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                }
                                              },
                                              [
                                                _vm._v("Ações"),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-arrow-down el-icon--right"
                                                })
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-menu",
                                              {
                                                attrs: { slot: "dropdown" },
                                                slot: "dropdown"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("el-dropdown-item", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "flex",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.editarSocio(
                                                                scope.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fal fa-pencil-alt"
                                                          }),
                                                          _vm._v("  Editar")
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  [
                                                    _c("el-dropdown-item", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "flex",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeSocio(
                                                                scope.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-times"
                                                          }),
                                                          _vm._v("  Remover")
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    errors.length
                      ? _c("span", { staticClass: "help erro" }, [
                          _vm._v(
                            "Deve ser registrado no mínimo um sócio e um representante legal."
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70810df4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70810df4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppSocioRetificacao.vue
// module id = null
// module chunks = 